export default {
    name: 'mvtCardMortgage',
    props: ['data', 'state', 'provider', 'openMortgage'],
    inject: ['$eventBus'],
    computed:{
        utmSource(){
            return this.provider && this.provider.toLowerCase().indexOf('bankrate') > -1 ? `&utm_source=movoto` : '';
        }
    },
    methods: {
        applyBtn() {
            if (this.provider) {
                this.$eventBus.$emit('ga', { el: this.provider + ' Click', props: { link_name: 'Next' } });
            }
        },
    },
};
